<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="headline primary white--text mb-2">
              <v-icon left dark>mdi-home-analytics</v-icon>
              Sala de Situação
            </v-card-title>
            <v-card-text>
              <v-alert color="info" icon="mdi-information" class="mb-4">
                <strong>{{ franquia?.descricao }}</strong>
                <v-divider class="my-2"></v-divider>
                <v-icon small class="mr-1">mdi-account-group</v-icon>
                {{ franquia?.turmas_count }} Turmas
                <br />
                <v-icon small class="mr-1">mdi-chart-line</v-icon>
                Média da Escola: {{ getNumeroSemArredondamento(getMediaDaEscola()) }}
                <br />
                <v-icon small class="mr-2">mdi-school</v-icon>
                Frequência da Escola:
                <v-chip
                  :color="getFrequenciaDaEscola().faltas > 0 ? 'error' : 'success'"
                  class="ml-2"
                  small
                >
                  <v-icon left small>
                    {{ getFrequenciaDaEscola().faltas > 0 ? "mdi-alert" : "mdi-check" }}
                  </v-icon>
                  {{ getFrequenciaDaEscola().faltas }} Faltas
                </v-chip>
                <v-chip
                  :color="getFrequenciaDaEscola().frequencia >= 80 ? 'success' : 'warning'"
                  class="ml-2"
                  small
                >
                  <v-icon left small>
                    {{
                      getFrequenciaDaEscola().frequencia >= 80 ? "mdi-arrow-up" : "mdi-arrow-down"
                    }}
                  </v-icon>
                  {{ getNumeroSemArredondamento(getFrequenciaDaEscola().frequencia) }}%
                </v-chip>
              </v-alert>
              <v-list dense class="elevation-1">
                <v-subheader class="font-weight-bold">
                  <v-icon left>mdi-book</v-icon>
                  Médias por Disciplina
                </v-subheader>
                <v-list-item
                  v-for="nota in mediaDeNotasDeCadaDisciplinaDaEscola"
                  :key="nota.disciplina_id"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-circle-small</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ nota.disciplina }}:</strong>
                      <v-chip small color="primary" class="ml-2">
                        {{ getNumeroSemArredondamento(nota.media) }}
                      </v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-for="turma in turmasList" :key="turma.id" class="mb-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Turma: {{ turma.descricao }}
              <v-spacer></v-spacer>
              <v-chip color="primary">Código: {{ turma.id }}</v-chip>
              <v-divider vertical class="mx-2"></v-divider>
              <v-chip color="primary">Matrículas: {{ turma.matriculas.length }}</v-chip>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-card outlined>
                    <v-card-text>
                      <v-icon color="primary" class="mr-2">mdi-chart-line</v-icon>
                      Média da Turma: {{ getNumeroSemArredondamento(getMediaDaTurma(turma.id)) }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card outlined>
                    <v-card-text>
                      <v-icon color="secondary" class="mr-2">mdi-school</v-icon>
                      Média da Escola: {{ getNumeroSemArredondamento(getMediaDaEscola()) }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card outlined class="mb-4">
                    <v-card-text class="d-flex align-center">
                      <v-icon color="primary" class="mr-2">mdi-chart-line</v-icon>
                      <span class="text-title"> Frequência da Turma: </span>
                      <v-spacer></v-spacer>
                      <v-chip
                        :color="getFrequenciaDaTurma(turma.id).faltas > 0 ? 'error' : 'success'"
                        class="ml-2"
                        small
                      >
                        <v-icon left small>
                          {{
                            getFrequenciaDaTurma(turma.id).faltas > 0 ? "mdi-alert" : "mdi-check"
                          }}
                        </v-icon>
                        {{ getFrequenciaDaTurma(turma.id).faltas }} Faltas
                      </v-chip>
                      <v-chip
                        :color="
                          getFrequenciaDaTurma(turma.id).frequencia >= 80 ? 'success' : 'warning'
                        "
                        class="ml-2"
                        small
                      >
                        <v-icon left small>
                          {{
                            getFrequenciaDaTurma(turma.id).frequencia >= 80
                              ? "mdi-arrow-up"
                              : "mdi-arrow-down"
                          }}
                        </v-icon>
                        {{ getNumeroSemArredondamento(getFrequenciaDaTurma(turma.id).frequencia) }}%
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card outlined>
                    <v-card-text>
                      <v-icon color="secondary" class="mr-2">mdi-school</v-icon>
                      Frequência da Escola:
                      <v-chip
                        :color="getFrequenciaDaEscola().faltas > 0 ? 'error' : 'success'"
                        class="ml-2"
                        small
                      >
                        <v-icon left small>
                          {{ getFrequenciaDaEscola().faltas > 0 ? "mdi-alert" : "mdi-check" }}
                        </v-icon>
                        {{ getFrequenciaDaEscola().faltas }} Faltas
                      </v-chip>
                      <v-chip
                        :color="getFrequenciaDaEscola().frequencia >= 80 ? 'success' : 'warning'"
                        class="ml-2"
                        small
                      >
                        <v-icon left small>
                          {{
                            getFrequenciaDaEscola().frequencia >= 80
                              ? "mdi-arrow-up"
                              : "mdi-arrow-down"
                          }}
                        </v-icon>
                        {{ getNumeroSemArredondamento(getFrequenciaDaEscola().frequencia) }}%
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-expansion-panels class="mt-4">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-icon class="mr-2"></v-icon>
                    Planos de Aulas da Turma
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-4">
                      <v-col>
                        <v-card>
                          <v-card-text class="d-flex align-center">
                            <v-icon color="primary" class="mr-2">mdi-book-multiple</v-icon>
                            <span class="text-title"> Total de Planos de Aula: </span>
                            <v-spacer></v-spacer>

                            <v-chip color="primary" class="ml-2" small>
                              {{
                                planosDeAulasPorTurma[turma.id].reduce(
                                  (total, item) => total + item.planos_bimestrais_count,
                                  0
                                )
                              }}
                            </v-chip>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Código</th>
                            <th class="text-left">Disciplina</th>
                            <th class="text-left">Planos Lançados</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in planosDeAulasPorTurma[turma.id]" :key="item.id">
                            <td>{{ item.disciplina.id }}</td>
                            <td>{{ item.disciplina.descricao }}</td>
                            <td>
                              <v-chip
                                :color="item.planos_bimestrais_count > 0 ? 'success' : 'warning'"
                                small
                              >
                                <v-icon left small>
                                  {{ item.planos_bimestrais_count > 0 ? "mdi-check" : "mdi-alert" }}
                                </v-icon>
                                {{ item.planos_bimestrais_count }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels class="mt-4">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-icon class="mr-2"></v-icon>
                    Disciplinas da Turma
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Código</th>
                            <th class="text-left">Disciplina</th>
                            <th class="text-left">Professor</th>
                            <th class="text-left">Média</th>
                            <th class="text-left">Frequência</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-for="turmaComFrequencia in turmasComFrequenciaPorDisciplina.filter(
                              (turmaComFrequencia, index) => turmaComFrequencia.id === turma.id
                            )"
                          >
                            <tr
                              v-for="gestao in turmaComFrequencia.gestao_de_aulas"
                              :key="gestao.id"
                            >
                              <td>{{ gestao.id }}</td>
                              <td>{{ gestao.disciplina.descricao }}</td>
                              <td>{{ gestao.professor.nome }}</td>
                              <td>
                                <v-chip
                                  :color="
                                    mediaDeNotasDeCadaDisciplinaDeCadaTurma[turma.id].find(
                                      (disciplina) =>
                                        disciplina.disciplina.id === gestao.disciplina.id
                                    )?.media >= 7
                                      ? 'success'
                                      : 'warning'
                                  "
                                  small
                                >
                                  {{
                                    mediaDeNotasDeCadaDisciplinaDeCadaTurma[turma.id].find(
                                      (disciplina) =>
                                        disciplina.disciplina.id === gestao.disciplina.id
                                    )?.media ?? "---"
                                  }}
                                </v-chip>
                              </td>
                              <td>
                                <v-icon
                                  v-if="gestao.faltas_count > 0"
                                  :color="
                                    (gestao.faltas_count /
                                      (gestao.aulas_ministradas_count *
                                        turmaComFrequencia.matriculas_count)) *
                                      100 >
                                    10
                                      ? 'error'
                                      : 'primary'
                                  "
                                  class="mr-1"
                                >
                                  mdi-alert-circle
                                </v-icon>
                                {{ gestao.faltas_count }} Faltas
                                <br />
                                <span
                                  :class="{
                                    'error--text':
                                      (gestao.faltas_count /
                                        (gestao.aulas_ministradas_count *
                                          turmaComFrequencia.matriculas_count)) *
                                        100 >
                                      10,
                                    'primary--text':
                                      (gestao.faltas_count /
                                        (gestao.aulas_ministradas_count *
                                          turmaComFrequencia.matriculas_count)) *
                                        100 <=
                                      10,
                                  }"
                                >
                                  {{
                                    getNumeroSemArredondamento(
                                      (gestao.faltas_count /
                                        (gestao.aulas_ministradas_count *
                                          turmaComFrequencia.matriculas_count)) *
                                        100
                                    )
                                  }}%
                                </span>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels class="mt-4">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-icon class="mr-2"></v-icon>
                    Matrículas da Turma
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Código</th>
                            <th class="text-left">Aluno</th>
                            <th class="text-left">Média mais alta</th>
                            <th class="text-left">Média mais baixa</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="matricula in turma.matriculas" :key="matricula.id">
                            <td>{{ matricula.aluno.codigo }}</td>
                            <td>{{ matricula.aluno.nomecompleto }}</td>
                            <td>
                              <v-chip color="primary" small>
                                <v-icon left small>mdi-trending-up</v-icon>
                                {{
                                  melhoresEPioresAvaliacoes.find(
                                    (avaliacao) => avaliacao.matricula_id === matricula.id
                                  ).melhorNota.nota_final
                                }}
                                -
                                {{
                                  melhoresEPioresAvaliacoes.find(
                                    (avaliacao) => avaliacao.matricula_id === matricula.id
                                  ).melhorNota.disciplina?.descricao
                                }}
                              </v-chip>
                            </td>
                            <td>
                              <v-chip color="error" small>
                                <v-icon left small>mdi-trending-down</v-icon>
                                {{
                                  melhoresEPioresAvaliacoes.find(
                                    (avaliacao) => avaliacao.matricula_id === matricula.id
                                  ).piorNota.nota_final
                                }}
                                -
                                {{
                                  melhoresEPioresAvaliacoes.find(
                                    (avaliacao) => avaliacao.matricula_id === matricula.id
                                  ).piorNota.disciplina?.descricao
                                }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      data: [],
      turmasList: [],
      franquia: null,
      melhoresEPioresAvaliacoes: [],
      mediaDeNotasDeCadaDisciplinaDeCadaTurma: [],
      turmasComFrequenciaPorDisciplina: [],
      mediaDeNotasDeCadaDisciplinaDaEscola: [],
      planosDeAulasPorTurma: [],
    };
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.$loaderService.open("Carregando Turmas");
      this.loading = true;
      try {
        this.data = await this.$services.salaDeSituacaoService.listarSalaDeSituacao();
        this.franquia = this.data.franquia;
        this.turmasList = this.data.turmas;
        this.melhoresEPioresAvaliacoes = this.data.melhoresEPioresAvaliacoes;
        this.mediaDeNotasDeCadaDisciplinaDeCadaTurma =
          this.data.mediaDeNotasDeCadaDisciplinaDeCadaTurma;
        this.turmasComFrequenciaPorDisciplina = this.data.frequenciaPorDisciplinaPorTurma;
        this.mediaDeNotasDeCadaDisciplinaDaEscola = this.data.mediaDeNotasDeCadaDisciplinaDaEscola;
        this.planosDeAulasPorTurma = this.data.planosDeAulas.planosDeAulasPorTurma;
      } catch (e) {
        this.$handleError(e);
      } finally {
        this.$loaderService.close();
        this.loading = false;
      }
    },
    getMediaDaTurma(turma_id) {
      if (
        !this.mediaDeNotasDeCadaDisciplinaDeCadaTurma[turma_id] ||
        !this.mediaDeNotasDeCadaDisciplinaDeCadaTurma[turma_id].length
      ) {
        return "0.00";
      }

      const sum = this.mediaDeNotasDeCadaDisciplinaDeCadaTurma[turma_id].reduce((total, item) => {
        const mediaValue = parseFloat(String(item.media).replace(",", "."));
        return total + (Number.isNaN(mediaValue) ? 0 : mediaValue);
      }, 0);

      return sum / this.mediaDeNotasDeCadaDisciplinaDeCadaTurma[turma_id].length;
    },
    getMediaDaEscola() {
      const keys = Object.keys(this.mediaDeNotasDeCadaDisciplinaDeCadaTurma);
      const notas = this.mediaDeNotasDeCadaDisciplinaDeCadaTurma;
      const result = keys.map((turma_id) => {
        return (
          notas[turma_id].reduce(
            (total, num) =>
              parseFloat(String(total).replace(",", ".")) +
              parseFloat(String(num.media).replace(",", ".")),
            0.0
          ) / notas[turma_id].length
        );
      });

      return (
        result.reduce(
          (total, num) =>
            parseFloat(String(total).replace(",", ".")) + parseFloat(String(num).replace(",", ".")),
          0.0
        ) / result.length
      );
    },
    getFrequenciaDaTurma(turma_id) {
      const dadosDaTurma = this.turmasComFrequenciaPorDisciplina.find(
        (turmaComFrequencia, index) => turmaComFrequencia.id === turma_id
      );

      const faltas = dadosDaTurma.gestao_de_aulas.reduce(
        (total, gestao) => total + gestao.faltas_count,
        0
      );

      const aulasMinistradas = dadosDaTurma.gestao_de_aulas.reduce(
        (total, gestao) => total + gestao.aulas_ministradas_count,
        0
      );

      const matriculas = dadosDaTurma.matriculas_count;

      return {
        frequencia: (faltas / (aulasMinistradas * matriculas)) * 100,
        faltas,
        aulasMinistradas,
        matriculas,
      };
    },
    getFrequenciaDaEscola() {
      const turmas = this.turmasComFrequenciaPorDisciplina;
      const result = turmas.map((turma) => {
        const dadosDaTurma = turmas.find((turmaComFrequencia, index) => {
          return turmaComFrequencia.id === turma.id;
        });

        const faltas = dadosDaTurma.gestao_de_aulas.reduce(
          (total, gestao) => total + gestao.faltas_count,
          0
        );

        const aulasMinistradas = dadosDaTurma.gestao_de_aulas.reduce(
          (total, gestao) => total + gestao.aulas_ministradas_count,
          0
        );

        const matriculas = dadosDaTurma.matriculas_count;

        return {
          frequencia: (faltas / (aulasMinistradas * matriculas)) * 100,
          faltas,
          aulasMinistradas,
          matriculas,
        };
      });

      return {
        frequencia: result.reduce(
          (total, num) => parseFloat(total) + parseFloat(num.frequencia),
          0.0
        ),
        faltas: result.reduce((total, num) => total + num.faltas, 0),
        aulasMinistradas: result.reduce((total, num) => total + num.aulasMinistradas, 0),
        matriculas: result.reduce((total, num) => total + num.matriculas, 0),
      };
    },
    getNumeroSemArredondamento(numero, precisao = 1) {
      const og = 10 ** precisao;
      return Math.trunc(numero * og) / og;
    },
  },
};
</script>

<style></style>
